import React from 'react';
import KnowledgeBaseNameCell from './KnowledgeBaseNameCell';
import KnowledgeStatusBadge from './KnowledgeStatusBadge';
import SyncButton from './SyncButton';
import { formatDate } from '../utils';

function KnowledgeBasesTable({ items, syncingIds, deletingId, onSync, onDelete }) {
  return (
    <div className="hidden md:block surface-card overflow-hidden">
      <table className="w-full text-sm table-fixed">
        <thead>
          <tr className="border-b border-surface-border bg-slate-50 text-left">
            <th className="px-4 py-3 font-medium text-content-muted w-[32%]">Nome</th>
            <th className="px-4 py-3 font-medium text-content-muted w-[16%]">Status</th>
            <th className="px-4 py-3 font-medium text-content-muted w-[14%]">Conteúdo</th>
            <th className="px-4 py-3 font-medium text-content-muted whitespace-nowrap w-[22%]">
              Atualizado
            </th>
            <th className="px-4 py-3 font-medium text-content-muted w-[16%]">Ações</th>
          </tr>
        </thead>
        <tbody>
          {items.map((kb) => (
            <tr
              key={kb.id}
              className="border-b border-surface-border last:border-b-0 hover:bg-slate-50/80 transition-colors"
            >
              <td className="px-4 py-3">
                <KnowledgeBaseNameCell kb={kb} />
              </td>
              <td className="px-4 py-3 whitespace-nowrap">
                <KnowledgeStatusBadge status={kb.status} />
              </td>
              <td className="px-4 py-3 text-content-muted whitespace-nowrap">
                {kb.chunk_count ?? 0} chunks
              </td>
              <td className="px-4 py-3 text-content-muted whitespace-nowrap">
                {formatDate(kb.last_synced_at || kb.last_source_check_at)}
              </td>
              <td className="px-4 py-3 whitespace-nowrap">
                <div className="flex items-center gap-3">
                  <SyncButton
                    kb={kb}
                    isSyncing={Boolean(syncingIds[kb.id])}
                    onSync={onSync}
                    compact
                  />
                  <button
                    type="button"
                    onClick={() => onDelete(kb)}
                    disabled={deletingId === kb.id}
                    className="text-sm text-red-600 hover:text-red-800 disabled:opacity-50"
                  >
                    {deletingId === kb.id ? 'Excluindo...' : 'Excluir'}
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default KnowledgeBasesTable;
